/**************************************************
 * Nombre:       Formulario_Producto_Comanda_Editar
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    CategoryOutlined,
    CoffeeMakerOutlined,
    FastfoodOutlined,
    MoneyOutlined,
    QrCodeOutlined,
    ScaleOutlined,
    WarehouseOutlined
} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelectPropId from "../../Modulo_formularios/Componentes/IngresoSelectPropId";

const Formulario_Producto_Comanda_Editar = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={FastfoodOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'Campo requerido'} editable={false}
                    />
                </Grid>



                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor'} dato={'valor'} {...props}
                                   requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto Icono={ScaleOutlined} nombre={'Cantidad'} dato={'cantidad'} {...props}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Notas'} dato={'notas'} {...props}/>
                </Grid>




            </Grid>

        </form>

    )

}
export default Formulario_Producto_Comanda_Editar